export const SPLIT_LOCAL_STORAGE_PREFIX = "SP_SPLIT";
